<template>
  <div class="cartEmptyInfo">
    <span class="cartEmptyInfo__icon" />
    Twój koszyk jest pusty
  </div>
</template>

<script>
export default {
  name: 'CartEmptyInfo',
};
</script>

<style lang="scss">
.cartEmptyInfo {
  position: relative;
  display: flex;
  padding-left: 2.5rem;
  align-items: center;
  justify-content: center;
  height: 5.5rem;
  background-color: $cBg;
  font-size: 1.6rem;
  line-height: 2.6rem;
  text-align: center;
  border-radius: 50px 4px 4px 50px;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    height: 5.5rem;
    width: 5.5rem;
    background-color: $cWhite;
    border-radius: 50%;
    border: 1px solid $cAddLight;

    &:before {
      @include icomoon('warning');
      color: $cSec;
      font-size: 2.8rem;
    }
  }
}
</style>
